import { personNameSorter, personRenderer } from '@lib/generic.utils'
import { checkboxCol } from '@/ag-grid/ag-columns'
import { notAnyValueCheck } from '@/ag-grid/utils/notAnyValue'

export const options = {
  computed: {
    options() {
      return {
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        columnDefs: [
          checkboxCol(),

          {
            headerName: 'Name',
            comparator: personNameSorter,
            cellRenderer: params => personRenderer(params.data)
          },

          {
            headerName: 'Email',
            field: 'email'
          },

          {
            headerName: 'Job Title',
            field: 'job',
            cellRenderer: notAnyValueCheck
          }
        ],
        domLayout: 'autoHeight'
      }
    }
  }
}
